import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  convertAmount,
  gameConfigStore,
  getAmountWithCurrency,
  TranslationKeys,
  useTranslation,
} from '@pascal/pascal-core';
import { doBetStore } from '../../../store/doBetStore';

export const MaxWinPopup = observer(() => {
  const { limits } = gameConfigStore;
  const { maxPayoutData } = doBetStore;

  const t = useTranslation();

  return (
    <>
      {Object.keys(maxPayoutData).map((item) => {
        const { isAlreadySeenPopUp, isShowPopUp, freeBetId } = maxPayoutData[item];

        return (
          <React.Fragment key={item}>
            {isShowPopUp && !isAlreadySeenPopUp && !freeBetId ? (
              <div className='max-win-popups'>
                <p className='max-win-pop-text'>{t(TranslationKeys.MaxWinPayout)}</p>
                <p className='max-win-pop-amount'>
                  {getAmountWithCurrency({
                    amount: convertAmount(limits?.maxWin || ''),
                  })}
                </p>
              </div>
            ) : null}
          </React.Fragment>
        );
      })}
    </>
  );
});
